import {
  FEATURE_CREDITS_API_KEYS,
  SUBSCRIPTIONS_API_KEYS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useCreditDetails } from "features/MySubscriptions/utils/useCreditDetails";
import { RESOURCE_KEYS } from "utils/OrgPermissions";

export const useCheckLTO = () => {
  const {
    data: {
      [FEATURE_CREDITS_API_KEYS.total_credits]: totalCredits,
      [FEATURE_CREDITS_API_KEYS.consumed_credits]: consumedCredits,
    } = {},
  } = useCreditDetails({
    params: {
      [SUBSCRIPTIONS_API_KEYS.feature_key]:
        RESOURCE_KEYS.SUBSECTIONS.LIMITED_TIME_OFFER.CREATE_LIMITED_TIME_OFFER,
    },
  });

  const creditsAvailable = totalCredits - consumedCredits;
  const canCreateLTO = consumedCredits < totalCredits;
  return {
    totalCredits,
    consumedCredits,
    creditsAvailable,
    canCreateLTO,
  };
};
